<div class="wrapper">
  <form [formGroup]="form">
    <div class="two-items">

      <div class="form-component">
        <mat-form-field>
          <mat-select
            formControlName="Layer"
            matTooltip="{{ 'configurations-fields.tooltips.Layer' | translate }}"
          >
            <mat-option *ngFor="let layer of layers" [value]="layer.Id"> {{ layer.Name }} ({{ layer.Slug }})
            </mat-option>
          </mat-select>
          <mat-placeholder>{{
            layers.length ? ('configurationTab.layer' | translate) : ('configurationTab.noLayer' | translate)
            }}</mat-placeholder>
        </mat-form-field>
      </div>

      <div class="form-component" formGroupName="ObjectTypeConfiguration">
        <mat-form-field>
          <mat-select
            matTooltip="{{ 'configurations-fields.tooltips.ObjectType' | translate }}"
            formControlName="ObjectType"
          >
            <mat-option [value]="null">{{ 'configurationTab.notSelected' | translate }}</mat-option>
            <mat-option *ngFor="let objectType of objectTypesOptions" [value]="objectType.value">
              {{ objectType.title | translate }}
            </mat-option>
          </mat-select>
          <mat-placeholder>{{ 'configurations-fields.ObjectType' | translate }}</mat-placeholder>
        </mat-form-field>
      </div>

    </div>


    <div class="two-items">
      <div class="form-component">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mat-form-field>
            <input
              matInput
              matTooltip="{{ 'configurations-fields.tooltips.Header' | translate }}"
              type="text"
              placeholder="{{ 'configurations-fields.Header' | translate }}"
              formControlName="Title"
              name="Header"
            />
            <button mat-button type="button" *ngIf="isTitleNotEmpty" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearTitle()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </ng-container>
      </div>

      <div class="form-component">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mat-form-field>
            <mat-select
              matTooltip="{{ 'configurations-fields.tooltips.TitleField' | translate }}"
              formControlName="TitleField"
            >
              <mat-option [value]="null">{{ 'configurationTab.notSelected' | translate }}</mat-option>

              <mat-option *ngFor="let field of placeMarksFields.PrimaryFields; let i = index"
                          [value]="placeMarksFields.TableKeys[i]">
                {{ field }}
              </mat-option>
            </mat-select>
            <mat-placeholder>{{ 'configurations-fields.TitleField' | translate }}</mat-placeholder>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="one-item">
      <div class="form-component main-color">
        <mee-color-picker formControlName="MainColor"></mee-color-picker>
      </div>
    </div>

    <p class="object-configuration-title">
      {{ 'configurations-fields.ObjectConfigurationTitle' | translate }}
    </p>


    <div class="two-items">
      <div class="form-component with-measurement">
        <mee-configuration-compound-input-new
          formControlName="DefaultDepth"
          placeholder="{{ 'configurations-fields.DefaultDepth' | translate }}"
          helpTooltip="{{ 'configurations-fields.tooltips.DepthAltitude' | translate }}"
        ></mee-configuration-compound-input-new>
      </div>

      <div class="form-component with-measurement with-invert-value">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mee-configuration-compound-select-new
            [placeMarksFields]="placeMarksFields"
            formControlName="DepthField"
            placeholder="{{ 'configurations-fields.DepthField' | translate }}"
            helpTooltip="{{ 'configurations-fields.tooltips.DepthAltitude' | translate }}"
          ></mee-configuration-compound-select-new>
        </ng-container>
      </div>
    </div>

    <ng-container formGroupName="ObjectTypeConfiguration">

      <div class="two-items">
        <div class="form-component with-measurement">
          <mee-configuration-compound-input-new
            formControlName="DefaultHeight"
            placeholder="{{ 'configurations-fields.BoundingBoxHeight' | translate }}"
            helpTooltip="{{ 'configurations-fields.tooltips.BoundingBoxHeight' | translate }}"
          ></mee-configuration-compound-input-new>
        </div>

        <div class="form-component with-measurement with-invert-value">
          <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
          <ng-container *ngIf="placeMarksFields">
            <mee-configuration-compound-select-new
              [placeMarksFields]="placeMarksFields"
              formControlName="HeightField"
              placeholder="{{ 'configurations-fields.BoundingBoxHeightField' | translate }}"
              helpTooltip="{{ 'configurations-fields.tooltips.BoundingBoxHeightField' | translate }}"
            ></mee-configuration-compound-select-new>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <p class="additional-details-title">
      {{ 'configurations-fields.AdditionalDetails' | translate }}
    </p>

    <div class="two-items">
      <div class="form-component">
        <mee-label-configuration
          formControlName="LabelConfiguration"
        ></mee-label-configuration>
      </div>

      <div class="form-component">
        <mee-info-card-image formControlName="PlacemarkImage"></mee-info-card-image>
      </div>
    </div>
  </form>
</div>

